import {
  useUserReduced,
  useUsersReduced,
} from '@/core/domain/enterprise/Users/Users.hooks';
import { PageRequest } from '@/core/request/PageRequest';
import useSelectOptions from '@/hooks/useSelectOptions';
import { SelectProps } from 'antd';
import InfiniteSelect from '../InfiniteSelect';
import { useState } from 'react';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: PageRequest;
  queryEnable?: boolean;
};

export default function UsersInfiniteSelectField({
  queryFilter,
  queryEnable = false,
  ...props
}: Props) {
  const [selectClicked, setSelectClicked] = useState<boolean>(queryEnable);

  const userList = useUsersReduced({ ...queryFilter }, selectClicked);
  const userDetail = useUserReduced();

  const employeeOptions = useSelectOptions({
    list: userList,
    detail: userDetail,
    selectProps: props,
    labelFormatter: (user) => user.employeeName,
  });

  const handleSelectClick = () => {
    if (!selectClicked) {
      setSelectClicked(true);
    }
  };

  return (
    <InfiniteSelect
      fetchNextPage={userList.fetchNextPage}
      hasNextPage={userList.hasNextPage}
      loading={userList.isFetching}
      options={employeeOptions}
      showSearch
      onClick={handleSelectClick}
      filterOption={false}
      {...props}
    />
  );
}
